import { render, staticRenderFns } from "./SubTasks.vue?vue&type=template&id=1d0d5ecb&scoped=true&"
import script from "./SubTasks.vue?vue&type=script&lang=js&"
export * from "./SubTasks.vue?vue&type=script&lang=js&"
import style0 from "./SubTasks.vue?vue&type=style&index=0&id=1d0d5ecb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0d5ecb",
  null
  
)

export default component.exports